import React from 'react';
import Popup from "./Popup";
import ConfirmationPopup from "./ConfirmPopup";

const PopupManager = ({
  showPopup,
  setShowPopup,
  showConfirmation,
  setShowConfirmation,
  popupMessage,
  isError,
  onConfirm,
  onRedirectToLogin
}) => {
  return (
    <>
      <ConfirmationPopup
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={onConfirm}
        message={popupMessage}
      />
      <Popup
        isOpen={showPopup}
        onClose={onRedirectToLogin}
        message={popupMessage}
        isError={isError}
      />
    </>
  );
};

export default PopupManager;